module.exports = __webpack_public_path__ + "static/provalindo-wiwit-nugroho-c1901c79d0ba898ae0a711596c84f716.png";